import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, resolveComponent as _resolveComponent, withCtx as _withCtx, withKeys as _withKeys, Transition as _Transition } from "vue"

const _hoisted_1 = { class: "panels-wrapper" }
const _hoisted_2 = { class: "standby-content content-panel" }
const _hoisted_3 = {
  key: 0,
  class: "sessions-panel"
}
const _hoisted_4 = { class: "header" }
const _hoisted_5 = {
  role: "group",
  title: "Actions",
  "aria-label": "Actions",
  class: "action-button-wrapper"
}
const _hoisted_6 = {
  title: "Pending Uploads",
  "aria-label": "Pending Uploads"
}
const _hoisted_7 = {
  key: 0,
  class: "pending-uploads-wrapper"
}
const _hoisted_8 = {
  "aria-": "",
  class: "pending-uploads-warning"
}
const _hoisted_9 = ["src"]
const _hoisted_10 = { class: "pending-uploads" }
const _hoisted_11 = {
  tabIndex: "0",
  class: "pending-upload-contents"
}
const _hoisted_12 = {
  key: 0,
  class: "upload-tooltip"
}
const _hoisted_13 = {
  key: 2,
  class: "upload-error"
}
const _hoisted_14 = { class: "accordion-length" }
const _hoisted_15 = { class: "accordion-length" }
const _hoisted_16 = {
  key: 1,
  class: "standby-card-wrapper"
}
const _hoisted_17 = ["src"]
const _hoisted_18 = {
  key: 1,
  class: "content"
}
const _hoisted_19 = { class: "input-row" }
const _hoisted_20 = { class: "error-container" }
const _hoisted_21 = {
  key: 0,
  class: "input-error"
}
const _hoisted_22 = {
  key: 2,
  class: "content"
}

import { ref, computed, onMounted, onBeforeMount, onBeforeUnmount, watch, useTemplateRef } from 'vue';
import { useRouter, useRoute } from 'vue-router';
import { useStore } from 'vuex';
import { useDebounceFn } from '@vueuse/core';
import BaseView from "../views/BaseView.vue";
import RoundedButton from "../components/RoundedButton.vue";
import ChevronLeftGreyIcon from "../assets/images/Chevron-left-grey.svg";
import Onboarding from "../components/Onboarding/Onboarding.vue";
import SubscriptionSignup from "../components/Onboarding/SubscriptionSignup.vue";
import { uploadMedia, recoverRecordings, tidyUploadCache, eventEmitter } from "../assets/uploadFile.js";
import UploadWhite from "../assets/images/Upload-white.svg";
import TrashIcon from "../assets/images/Trash-white.svg";
import ConfirmationModal from "../components/ConfirmationModal.vue";
import ItemList from "../components/Home/ItemList.vue";
import RowActionMenubar from "../components/Home/RowActionMenubar.vue";
import RequestNotesOrderForm from "../components/Orders/RequestNotesOrderForm.vue";
import TitleChangeModal from "../components/TitleChangeModal.vue";
import ActionButton from '../components/Home/ActionButton.vue';
import FolderModal from "../components/FolderModal.vue";
import MoveSessionModal from "../components/MoveSessionModal.vue";
import { useOrderForm } from "@/composables/useOrderForm";
import { useTitleChangeModal } from '@/composables/useTitleChangeModal';
import { useSupplementaryUpload } from '@/composables/useSupplementaryUpload';
import { SessionWithOrdersAndType, CachedLocalSession } from '@/types/session-interfaces';
import { Folder } from '@/types/folder-interfaces';
import { Order, OrderStatus } from '@/types/order-interfaces';
import { ItemListColumn } from '@/types/itemlist-interfaces';
import IconButton from '@/components/IconButton.vue';

// UUID validation regex
const idealRowHeight = 10.2


export default /*@__PURE__*/_defineComponent({
  __name: 'Home',
  setup(__props) {

const uuidV4Regex = /^[A-F\d]{8}-[A-F\d]{4}-4[A-F\d]{3}-[89AB][A-F\d]{3}-[A-F\d]{12}$/i;

// Setup router and store
const router = useRouter(),
      route = useRoute(),
      store = useStore();

// Import composables
const {
  orderFormVisible,
  sessionTitle,
  requestNotes,
  durationHMS,
  durationMilliseconds,
  recordingUploadId,
  setOrderFormVisible,
} = useOrderForm();

const { triggerFileUpload } = useSupplementaryUpload();

const {
  titleChangeModalVisible,
  selectedType,
  selectedTitle,
  selectedId,
  openTitleChangeModal,
  setTitleChangeModal,
} = useTitleChangeModal();

// Refs for template elements
const confirmationModal = ref(),
      foldersListComponent = ref();

// This needs to be a computed property to ensure it updates AFTER the ItemList renders
// as the RowActionMenubar is only mounted after the ItemList is rendered
const sessionsListComponent:any = computed(() => sessionsList.value);

// State variables
const documentName = ref<string>(""),
      notetakerId = ref<string>(""),
      errorMessage = ref<string>(""),
      showPrebookedMenu = ref<boolean>(false),
      showInstantMenu = ref<boolean>(false),
      hideBackButton = ref<boolean>(false),
      justSubscribed = ref<boolean>(false),
      showSubscriptionSignupDialog = ref<boolean>(true),
      sessionUploadingId = ref<string | null>(null),
      sessionErrorId = ref<string>(""),
      uploadErrorMessage = ref<string>(""),
      uploadProgress = ref<number>(0),
      uploadButtonText = ref<string>("Upload"),
      sessionsLoading = ref<boolean>(true),
      foldersLoading = ref<boolean>(true),
      folderModalVisible = ref<boolean>(false),
      moveSessionModal = ref(),
      sessionSortField = ref<string>(""),
      sessionSortOrder = ref<string>("");

// template refs for components
const sessionsList = useTemplateRef("sessionsList"),
      foldersList = useTemplateRef("foldersList"),
      orderFormRef = useTemplateRef("orderForm"),
      confirmationModalRef = useTemplateRef("confirmationModalRef"),
      moveSessionModalRef = useTemplateRef("moveSessionModal");

// Table related state
const folderColumns = ref<ItemListColumn[]>([]);
const sessionColumns = ref<ItemListColumn[]>([]);

const sessionMenuProps = ref<Array<{
  label?: string;
  icon?: string;
  // eslint-disable-next-line no-unused-vars
  command?: (rowData: any) => void;
  // eslint-disable-next-line no-unused-vars
  checkLabel?: (rowData: any) => string;
  // eslint-disable-next-line no-unused-vars
  checkVisible?: (rowData: any) => boolean;
  // eslint-disable-next-line no-unused-vars
  checkDisable?: (rowData: any) => boolean;
}>>([]);
// eslint-disable-next-line no-unused-vars
const folderMenuProps = ref<{ label: string; icon: string; command: (rowData: any) => void; }[]>([]);

// User info
const userFirstName = computed(() => store.state.user.currentUser.self.name.firstName || '');

// Watchers for error message clearing
watch(documentName, (newName) => {
  if (newName !== "") {
    errorMessage.value = '';
  }
});

watch(notetakerId, (newName) => {
  if (newName !== "") {
    errorMessage.value = '';
  }
});

// We want our lists to flex below a certain number of items, so we calculate the height based on
// the number of items
//
// Once the number of items exceeds a certain threshold, we set a fixed height and let the list's
// internal scrolling handle the overflow
//
// We can't just use `flex` because virtual scrolling doesn't work well with flexbox in PrimeVue
//
// `idealRowHeight` is guesstimated based on the row element height, gap, padding, etc.
// We then add a bit more at the end to account for headers, padding on the table, etc.
const calculatedFolderListHeight = computed(() => {
  if (!allFolders.value.length) {
    return `${idealRowHeight + 12}rem`;
  }
  return `${((allFolders.value.length >= 4) ? (idealRowHeight * 4) : (idealRowHeight * allFolders.value.length)) + 12}rem`;
});

const calculatedSessionListHeight = computed(() => {
  if (!allSessions.value.length) {
    return `${idealRowHeight + 20}rem`;
  }
  return `${((allSessions.value.length >= 10) ? (idealRowHeight * 10) : (idealRowHeight * allSessions.value.length)) + 20}rem`;
});

// Methods

/**
 * When the session sort field or order changes, this function will be called to reload the sessions.
 * We debounce it because both the sort field and order can change at the same time, so we don't want
 * to reload the sessions multiple times in quick succession.
 */
const debouncedReloadSessions = useDebounceFn(() => {
  store.dispatch('itemList/reloadSessions', {sortField: sessionSortField.value, sortOrder: sessionSortOrder.value}).then(() => {
    sessionsLoading.value = false;
    foldersLoading.value = false;
  }).catch((error) => {
    console.error('Error reloading sessions:', error);
    sessionsLoading.value = false;
    foldersLoading.value = false;
  });
}, 1000, { maxWait: 3000 })

const onSortChange = async (sortField: string) => {
  if (sessionSortField.value === sortField) return;
  sessionSortField.value = sortField
  updateDataTableState(sortField, undefined);
  sessionsLoading.value = true
  debouncedReloadSessions()
}

const onSortOrderChange = async (sortOrder: number|undefined) => {
  const sortOrderValue = sortOrder && sortOrder > 0 ? 'asc' : 'desc';
  if (sessionSortOrder.value === sortOrderValue) return;
  sessionSortOrder.value = sortOrderValue;
  updateDataTableState(undefined, sortOrder);
  sessionsLoading.value = true
  debouncedReloadSessions()
}

const updateDataTableState = (sortField?: string, sortOrder?: number) => {
  const currentState = JSON.parse(localStorage.getItem("session-table") || "{}");
  if (sortField !== undefined) currentState.sortField = sortField;
  if (sortOrder !== undefined) currentState.sortOrder = sortOrder;
  localStorage.setItem("session-table", JSON.stringify(currentState));
}

const setShowSubscriptionSignupDialog = (isVisible: boolean) => {
  showSubscriptionSignupDialog.value = isVisible;
};

const openFolderModal = () => {
  folderModalVisible.value = true;
};

const setFolderModal = (isVisible: boolean) => {
  folderModalVisible.value = isVisible;
};

const goToSession = () => {
  if (documentName.value === "") {
    errorMessage.value = "Blank session id! Please enter a valid session ID.";
  } else {
    const isValidUUID = uuidV4Regex.test(documentName.value);
    if (isValidUUID) {
      store.commit("user/setSessionDetails", {
        id: documentName.value,
      });
      router.push({
        name: "SessionInitializer",
      });
    } else {
      errorMessage.value = "The session id format is invalid.";
    }
  }
};

const goToSessionSetup = () => {
  router.push({
    name: "SessionSetup",
    query: { hideBackButton: String(hideBackButton.value)},
  });
};

const setJustSubscribed = (subscribed: boolean) => {
  justSubscribed.value = subscribed;
};

const resumeSessionUpload = (cachedSession: CachedLocalSession) => {
  sessionErrorId.value = '';
  uploadErrorMessage.value = '';
  sessionUploadingId.value = cachedSession.localSessionId;
  uploadButtonText.value = "Uploading...";
  
  uploadMedia(
    cachedSession.recordingTitle,
    cachedSession.recordingDuration,
    cachedSession.recordingDurationHMS,
    cachedSession.recordingCachePath,
    cachedSession.uploadType,
    cachedSession.uploadType == "mp-video",
    cachedSession.localSessionId,
    cachedSession,
    store
  ).then((uploadDataObject) => {
    if(uploadDataObject.errorMessage) {
      sessionErrorId.value = uploadDataObject.localSessionId;
      uploadErrorMessage.value = uploadDataObject.errorMessage;
    }
    
    sessionUploadingId.value = null;
  });
};

const deleteCachedSession = async (cachedSession: CachedLocalSession) => {
  const confirmed = await confirmationModal.value.show();

  if(confirmed) {
    tidyUploadCache(cachedSession, store);
  }
};

const open = (data: SessionWithOrdersAndType, status: string, statusDetail: OrderStatus, order: Order) => {
  store.commit("user/setSessionDetails", {
    status: status,
    statusDetail: statusDetail,
    order: order,
    ...data,
  });
  router.push({
    name: "SessionInitializer",
  });
};

const getUserSessionInfo = async () => {
  sessionsLoading.value = true;
  foldersLoading.value = true;

  folderColumns.value = [
    { 
      field: "title", 
      header: "TITLE", 
      sortable: true, 
      width: "79.77%",
    },
    {
      field: "createdAt",
      header: "CREATED",
      sortable: true,
      width: "15.36%",
    },
    { 
      field: "num", 
      header: "", 
      icon: true, 
      class: "small",
      width: "4.86%",
    },
  ];

  sessionColumns.value = [
    { 
      field: "title", 
      header: "TITLE", 
      sortable: true, 
      width: "44.44%",
    },
    {
      field: "noteStatus",
      header: "NOTES STATUS",
      sortable: false,
      width: "14.58%",
    },
    {
      field: "uploads",
      sortable: false,
      sortFunction: (session1: SessionWithOrdersAndType, session2: SessionWithOrdersAndType) => {
        return (session1.uploads?.length ?? 0) - (session2.uploads?.length ?? 0);
      },
      header: "SUPPLEMENTARY FILES",
      width: "20.75%",
    },
    {
      field: "createdAt",
      header: "CREATED",
      sortable: true,
      width: "15.36%",
    },
    { 
      field: "num", 
      header: "", 
      icon: true, 
      class: "small",
      width: "4.86%",
    },
  ]

  sessionMenuProps.value = [
    {
      label: "Open",
      icon: "itemlist-open-svg-icon",
      command: (rowData) => {
        // TODO: fix this handling when Anthill status is fixed
        if (
          rowData.type === "session" &&
          rowData.uploads.anthillProjectStatus &&
          rowData.uploads.anthillProjectStatus === "Done"
        ) {
          open(rowData, rowData.noteStatus, rowData.orderStatus, rowData.orders);
        } else {
          open(rowData, rowData.noteStatus, rowData.orderStatus, rowData.orders);
        }
      },
      // checkDisabled: (rowData) => !rowData.uploads.anthillProjectStatus,
    },
    {
      label: "Request Professional Note",
      command: (rowData) => {
        requestNotes(rowData);
      },
      icon: "itemlist-requestnotes-svg-icon",
      checkLabel: (rowData) => {
        return rowData.noteStatus !== "no-value" ? "Notes Requested" : "Request Professional Notes";
      },
      checkVisible: (rowData) => {
        return !(rowData.uploads && rowData.uploads[0] && rowData.uploads[0].type === "mp-document") && 
          !(rowData.uploads && rowData.uploads[0] && rowData.uploads[0].type === "mp-instant-session") &&
          hasProNoteAccess.value;
      },
      checkDisable: (rowData) => { return rowData.noteStatus !== "no-value"; }
    },
    {
      label: "Add Supplementary Material",
      command: (rowData) => {
        triggerFileUpload(rowData.id);
      },
      icon: "itemlist-upload-white-svg-icon",
      checkDisable: (rowData) => { return rowData.uploads.filter((upload: any) => upload.type === "mp-supplementary").length > 4; }
    },
    {
      label: "Copy Session ID",
      command: (rowData) => {
        copySessionId(rowData.id);
      },
      icon: "itemlist-copy-svg-icon",
    },
    {
      label: "Rename",
      icon: "itemlist-rename-svg-icon",
      command: (rowData) => {
        openTitleChangeModal(rowData);
      },
    },
  ];

  folderMenuProps.value = [
    {
      label: "Open",
      icon: "itemlist-open-svg-icon",
      command: (rowData) => {
        goToFolder(rowData);
      },
    },
    {
      label: "Rename",
      icon: "itemlist-rename-svg-icon",
      command: (rowData) => {
        openTitleChangeModal(rowData);
      },
    },
  ];

  sessionsLoading.value = false;
  foldersLoading.value = false;
};

const getMoreData = async () => {
  await store.dispatch('itemList/fetchAllDataMore', {sortField: sessionSortField.value, sortOrder: sessionSortOrder.value});
}

const canLoadMoreData = computed(() => {
  if (!store.state.itemList.sessionPagination || !store.state.itemList.folderPagination) {
    return true;
  }

  const canLoadMoreSessions = store.state.itemList.sessionPagination.nextPage !== null;
  const canLoadMoreFolders = store.state.itemList.folderPagination.nextPage !== null;

  return canLoadMoreFolders || canLoadMoreSessions;
});

const openSession = (session: SessionWithOrdersAndType) => {
  store.commit("user/setSessionDetails", {
    status: session.noteStatus,
    statusDetail: session.orderStatus,
    order: session.orders,
    ...session,
  });
  router.push({
    name: "SessionInitializer",
  });
};

const goToFolder = (folder: Folder) => {
  router.push(`/folder/${folder.id}?title=${folder.title}`);
};

const clearOrderFormValues = () => {
  if (orderFormRef.value) {
    orderFormRef.value.orderSubmitted = false;
    orderFormRef.value.step = 0;
    orderFormRef.value.orderSubmissionErrorMessage = "";
  }
};

const copySessionId = (sessionId: string): void => {
  console.debug("RowData ", sessionId);
  try {
    navigator.clipboard.writeText(sessionId);
  } catch (error: unknown) {
    console.log(error);
  }
};

const setupTableInfo = async () => {

      await getUserSessionInfo();

      sessionsLoading.value = false;
      foldersLoading.value = false;
      
};

const openMoveSessionModal = async () => {
  await moveSessionModal.value?.show();
};

const isOrgUser = computed(() => {
  return store.state.user.currentUser.type.toLowerCase().trim() === "org user";
});

const hasProNoteAccess = computed(() => {
  return store.getters['user/hasProNotesEnabled'];
});

const cachedSessions = computed(() => {
  return store.getters['user/cachedSessions'];
});

const allItems = computed({
  get: () => store.getters['itemList/getAllItems'],
  set: (val) => store.dispatch('itemList/updateAllItems', val)
});

const allFolders = computed({
  get: () => store.getters['itemList/getAllFolders'],
  set: (val) => store.dispatch('itemList/updateAllFolders', val)
});

const allSessions = computed({
  get: () => store.getters['itemList/getAllSessions'],
  set: (val) => store.dispatch('itemList/updateAllSessions', val)
});

const isDataLoaded = computed(() => {
  return allItems.value.length > 0;
});

const rowActionVisible = computed(() => store.state.itemList.selectedItems.length > 0);

const initPageData = async () => {
  const sortOptions = localStorage.getItem("session-table")
  let sortField = "createdAt"
  let sortOrder = "desc"
  if(sortOptions) {
    const parsedOptions = JSON.parse(sortOptions)
    sortField = parsedOptions.sortField
    sortOrder = parseInt(parsedOptions.sortOrder) > 0 ? 'asc' : 'desc'
  }
  await store.dispatch('itemList/fetchAllData', {sortField, sortOrder});
};

// Lifecycle hooks
onBeforeMount(async () => {
  if (!isDataLoaded.value) {
    // Read in any persisted default sort options from localStorage
    // and use them to fetch the initial data for the sessions list.
    const sortOptions = localStorage.getItem("session-table")
    let sortField = "createdAt"
    let sortOrder = "desc"
    if(sortOptions) {
      const parsedOptions = JSON.parse(sortOptions)
      sortField = parsedOptions.sortField
      sortOrder = parseInt(parsedOptions.sortOrder) > 0 ? 'asc' : 'desc'
    }
    await store.dispatch('itemList/fetchAllData', {sortField, sortOrder});
  }
});

onMounted(async () => {
  //Clear any corrupted sessions
  store.commit('user/removeCorruptedCachedSessions');

  //Attempt to recover any lost recordings
  recoverRecordings(store);

  eventEmitter.on("uploadProgress", ({localSessionId, progress}) => {
    if(localSessionId == sessionUploadingId.value) {
      uploadProgress.value = progress * 100.0;
    }
  });

  await setupTableInfo();
  foldersListComponent.value = foldersList.value;
  confirmationModal.value = confirmationModalRef.value;
  moveSessionModal.value = moveSessionModalRef.value;
});

onBeforeUnmount(() => {
  store.commit("itemList/clearSelection");
  eventEmitter.removeAllListeners("uploadProgress");
});

return (_ctx: any,_cache: any) => {
  const _component_ProgressBar = _resolveComponent("ProgressBar")!
  const _component_AccordionHeader = _resolveComponent("AccordionHeader")!
  const _component_AccordionContent = _resolveComponent("AccordionContent")!
  const _component_AccordionPanel = _resolveComponent("AccordionPanel")!
  const _component_Accordion = _resolveComponent("Accordion")!
  const _component_InputText = _resolveComponent("InputText")!
  const _component_Card = _resolveComponent("Card")!
  const _component_Toast = _resolveComponent("Toast")!
  const _directive_tooltip = _resolveDirective("tooltip")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(SubscriptionSignup, {
        visible: 
        _unref(route).query.firstLogin === 'true' &&
        !_unref(store).getters['user/currentUserSubscriptionActive'] &&
        !isOrgUser.value &&
        showSubscriptionSignupDialog.value
      ,
        setVisible: setShowSubscriptionSignupDialog
      }, null, 8, ["visible"]),
      (
        _unref(route).query.firstLogin === 'true' && !showSubscriptionSignupDialog.value
      )
        ? (_openBlock(), _createBlock(Onboarding, {
            key: 0,
            setJustSubscribed: setJustSubscribed
          }))
        : _createCommentVNode("", true),
      _createVNode(BaseView, null, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_2, [
            (!showPrebookedMenu.value && !showInstantMenu.value)
              ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                  _createElementVNode("h1", _hoisted_4, "Welcome, " + _toDisplayString(userFirstName.value), 1),
                  _createElementVNode("section", _hoisted_5, [
                    _createVNode(ActionButton, {
                      type: "record",
                      onClick: () => _unref(router).push({ name: 'Recorder', params: { recorderType: 'audioRecorder' } }),
                      label: "Record Audio"
                    }, null, 8, ["onClick"]),
                    _createVNode(ActionButton, {
                      type: "upload",
                      onClick: () => _unref(router).push({ name: 'Upload' }),
                      label: "Upload File"
                    }, null, 8, ["onClick"]),
                    _createVNode(ActionButton, {
                      type: "newfolder",
                      onClick: openFolderModal,
                      label: "Add New Folder"
                    })
                  ]),
                  _createElementVNode("section", _hoisted_6, [
                    (cachedSessions.value.length > 0)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                          _createElementVNode("div", _hoisted_8, [
                            _createElementVNode("img", {
                              "aria-hidden": "true",
                              alt: "upload icon",
                              src: _unref(UploadWhite),
                              class: "pending-uploads-icon"
                            }, null, 8, _hoisted_9),
                            _createElementVNode("h5", null, "You have " + _toDisplayString(cachedSessions.value.length) + " session" + _toDisplayString(cachedSessions.value.length === 1 ? '' : 's') + " to upload", 1)
                          ]),
                          _createElementVNode("div", _hoisted_10, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(cachedSessions.value, (item) => {
                              return (_openBlock(), _createElementBlock("div", {
                                key: item.localSessionId
                              }, [
                                _createElementVNode("div", _hoisted_11, [
                                  (item.isRecoveredFile)
                                    ? _withDirectives((_openBlock(), _createElementBlock("span", _hoisted_12, [
                                        _createTextVNode("Recovered:  " + _toDisplayString(item.recordingTitle), 1)
                                      ])), [
                                        [_directive_tooltip, 'This recording was interrupted before it was saved - we\'ve recovered what we can for you.']
                                      ])
                                    : _createCommentVNode("", true),
                                  (sessionUploadingId.value === item.localSessionId)
                                    ? (_openBlock(), _createBlock(_component_ProgressBar, {
                                        key: 1,
                                        class: "progress-bar",
                                        value: uploadProgress.value,
                                        showValue: false
                                      }, null, 8, ["value"]))
                                    : _createCommentVNode("", true),
                                  (sessionErrorId.value == item.localSessionId)
                                    ? (_openBlock(), _createElementBlock("span", _hoisted_13, "Error! " + _toDisplayString(uploadErrorMessage.value), 1))
                                    : _createCommentVNode("", true)
                                ]),
                                _createElementVNode("div", null, [
                                  _createVNode(RoundedButton, {
                                    class: "upload-button",
                                    text: sessionUploadingId.value === item.localSessionId ? 'Uploading...' : 'Upload',
                                    onClick: ($event: any) => (resumeSessionUpload(item)),
                                    loading: sessionUploadingId.value === item.localSessionId,
                                    disabled: sessionUploadingId.value !== null,
                                    "aria-label": `Upload ${item.recordingTitle}`
                                  }, null, 8, ["text", "onClick", "loading", "disabled", "aria-label"]),
                                  (sessionUploadingId.value !== item.localSessionId)
                                    ? (_openBlock(), _createBlock(IconButton, {
                                        key: 0,
                                        icon: _unref(TrashIcon),
                                        alt: "Remove session",
                                        onclick: () => deleteCachedSession(item),
                                        "enter-press": () => {
                        deleteCachedSession(item)
                      },
                                        dark: "",
                                        xsmall: "",
                                        ariaLabel: "Move to bin"
                                      }, null, 8, ["icon", "onclick", "enter-press"]))
                                    : _createCommentVNode("", true)
                                ])
                              ]))
                            }), 128))
                          ])
                        ]))
                      : _createCommentVNode("", true)
                  ]),
                  (isDataLoaded.value)
                    ? (_openBlock(), _createBlock(_component_Accordion, {
                        key: 0,
                        value: ['0', '1'],
                        multiple: ""
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_AccordionPanel, { value: "0" }, {
                            default: _withCtx(() => [
                              _createVNode(_component_AccordionHeader, null, {
                                default: _withCtx(() => [
                                  _createElementVNode("span", _hoisted_14, "(" + _toDisplayString(allFolders.value.length) + ")", 1),
                                  _cache[3] || (_cache[3] = _createElementVNode("span", { class: "accordion-header" }, "My folders ", -1))
                                ]),
                                _: 1,
                                __: [3]
                              }),
                              _createVNode(_component_AccordionContent, null, {
                                default: _withCtx(() => [
                                  _createVNode(ItemList, {
                                    ref_key: "foldersList",
                                    ref: foldersList,
                                    data: allFolders.value,
                                    columns: folderColumns.value,
                                    loader: foldersLoading.value,
                                    sessionMenuProps: sessionMenuProps.value,
                                    folderMenuProps: folderMenuProps.value,
                                    openSession: openSession,
                                    openFolder: goToFolder,
                                    lazyLoading: false,
                                    storageKey: "folder-table",
                                    scrollHeight: calculatedFolderListHeight.value
                                  }, null, 8, ["data", "columns", "loader", "sessionMenuProps", "folderMenuProps", "scrollHeight"])
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_AccordionPanel, { value: "1" }, {
                            default: _withCtx(() => [
                              _createVNode(_component_AccordionHeader, null, {
                                default: _withCtx(() => [
                                  _createElementVNode("span", _hoisted_15, "(" + _toDisplayString(allSessions.value.length || '0') + ")", 1),
                                  _cache[4] || (_cache[4] = _createElementVNode("span", { class: "accordion-header" }, "My Sessions ", -1))
                                ]),
                                _: 1,
                                __: [4]
                              }),
                              _createVNode(_component_AccordionContent, null, {
                                default: _withCtx(() => [
                                  _createVNode(ItemList, {
                                    ref_key: "sessionsList",
                                    ref: sessionsList,
                                    data: allSessions.value,
                                    columns: sessionColumns.value,
                                    loader: sessionsLoading.value,
                                    sessionMenuProps: sessionMenuProps.value,
                                    folderMenuProps: folderMenuProps.value,
                                    openSession: openSession,
                                    openFolder: goToFolder,
                                    lazyLoading: true,
                                    onLazyLoad: getMoreData,
                                    canLoadMore: canLoadMoreData.value,
                                    storageKey: "session-table",
                                    onSortChange: onSortChange,
                                    onSortOrderChange: onSortOrderChange,
                                    scrollHeight: calculatedSessionListHeight.value
                                  }, null, 8, ["data", "columns", "loader", "sessionMenuProps", "folderMenuProps", "canLoadMore", "scrollHeight"])
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true)
                ]))
              : (_openBlock(), _createElementBlock("div", _hoisted_16, [
                  _createVNode(_component_Card, { class: "join-session-card card" }, {
                    content: _withCtx(() => [
                      (!hideBackButton.value)
                        ? (_openBlock(), _createElementBlock("button", {
                            key: 0,
                            class: "back-button",
                            onClick: _cache[0] || (_cache[0] = 
                  () => {
                    showPrebookedMenu.value = false;
                    showInstantMenu.value = false;
                  }
                ),
                            "aria-label": 'Back ',
                            onKeydown: _cache[1] || (_cache[1] = ($event) => {
                  if ($event.key === 'Enter') {
                    showPrebookedMenu.value = false;
                    showInstantMenu.value = false;
                  }
                })
                          }, [
                            _createElementVNode("img", { src: _unref(ChevronLeftGreyIcon) }, null, 8, _hoisted_17),
                            _cache[5] || (_cache[5] = _createElementVNode("span", null, "Back", -1))
                          ], 32))
                        : _createCommentVNode("", true),
                      (showPrebookedMenu.value)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
                            _cache[6] || (_cache[6] = _createElementVNode("p", { class: "title" }, " Please enter the session ID you wish to access ", -1)),
                            _createElementVNode("div", _hoisted_19, [
                              _withDirectives(_createVNode(_component_InputText, {
                                id: "document-name",
                                placeholder: "Session ID",
                                type: "text",
                                modelValue: documentName.value,
                                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((documentName).value = $event)),
                                modelModifiers: { trim: true },
                                onKeyup: _withKeys(goToSession, ["enter"])
                              }, null, 8, ["modelValue"]), [
                                [
                                  _directive_tooltip,
                                  'Enter a session ID as found on Beehive',
                                  void 0,
                                  { top: true }
                                ]
                              ]),
                              _createVNode(RoundedButton, {
                                text: "Join",
                                onClick: goToSession,
                                enterPress: goToSession,
                                ariaLabel: `Join session ${documentName.value}`,
                                accent: "",
                                morePadding: "",
                                lessRound: "",
                                wide: ""
                              }, null, 8, ["ariaLabel"])
                            ]),
                            _createElementVNode("div", _hoisted_20, [
                              _createVNode(_Transition, {
                                name: "slide-up",
                                mode: "out-in"
                              }, {
                                default: _withCtx(() => [
                                  (errorMessage.value)
                                    ? (_openBlock(), _createElementBlock("p", _hoisted_21, _toDisplayString(errorMessage.value), 1))
                                    : _createCommentVNode("", true)
                                ]),
                                _: 1
                              })
                            ])
                          ]))
                        : (_openBlock(), _createElementBlock("div", _hoisted_22, [
                            _cache[7] || (_cache[7] = _createElementVNode("p", { class: "title" }, "Instant Session", -1)),
                            _cache[8] || (_cache[8] = _createElementVNode("p", { class: "subtitle" }, " Instantly generate a new Messenger Pigeon session ", -1)),
                            _createVNode(RoundedButton, {
                              text: "Start Session",
                              "aria-label": 'Start session',
                              enterPress: () => goToSessionSetup,
                              onClick: goToSessionSetup,
                              slim: "",
                              fitWidth: "",
                              lessRound: "",
                              accent: ""
                            }, null, 8, ["enterPress"])
                          ]))
                    ]),
                    _: 1
                  })
                ]))
          ])
        ]),
        _: 1
      }),
      _createVNode(ConfirmationModal, {
        class: "confirmation-modal",
        modal: "",
        header: "Delete recording?",
        buttonTextConfirm: "Delete",
        buttonTextCancel: "Cancel",
        smallerTitle: "",
        ref_key: "confirmationModalRef",
        ref: confirmationModalRef
      }, {
        default: _withCtx(() => _cache[9] || (_cache[9] = [
          _createElementVNode("p", null, " This session hasn't finished uploading. ", -1),
          _createElementVNode("p", null, " If you delete it, we won't be able to recover it. ", -1)
        ])),
        _: 1,
        __: [9]
      }, 512)
    ]),
    _createVNode(TitleChangeModal, {
      "session-title": _unref(selectedTitle),
      "session-id": _unref(selectedId),
      itemId: _unref(selectedId),
      itemTitle: _unref(selectedTitle),
      itemType: _unref(selectedType),
      visible: _unref(titleChangeModalVisible),
      setVisible: _unref(setTitleChangeModal)
    }, null, 8, ["session-title", "session-id", "itemId", "itemTitle", "itemType", "visible", "setVisible"]),
    _createVNode(RequestNotesOrderForm, {
      visible: _unref(orderFormVisible),
      recordingTitle: _unref(sessionTitle),
      durationHMS: _unref(durationHMS),
      durationMilliseconds: _unref(durationMilliseconds),
      recordingUploadId: _unref(recordingUploadId),
      setOrderFormVisible: _unref(setOrderFormVisible),
      onHide: clearOrderFormValues,
      onUpdateStandbySessionsMenuItem: getUserSessionInfo,
      ref: "orderForm"
    }, null, 8, ["visible", "recordingTitle", "durationHMS", "durationMilliseconds", "recordingUploadId", "setOrderFormVisible"]),
    (sessionsListComponent.value)
      ? (_openBlock(), _createBlock(RowActionMenubar, {
          key: 0,
          toggleSessionMenu: sessionsListComponent.value?.toggleSessionMenu,
          visible: rowActionVisible.value,
          onRenameItem: _unref(openTitleChangeModal),
          onMoveItem: openMoveSessionModal
        }, null, 8, ["toggleSessionMenu", "visible", "onRenameItem"]))
      : _createCommentVNode("", true),
    _createVNode(MoveSessionModal, {
      ref_key: "moveSessionModal",
      ref: moveSessionModal,
      onReloadPage: initPageData
    }, null, 512),
    _createVNode(FolderModal, {
      visible: folderModalVisible.value,
      setVisible: setFolderModal
    }, null, 8, ["visible"]),
    _createVNode(_component_Toast, {
      position: "top-center",
      group: "notification",
      class: "itemlist-notification-toast-wrapper"
    })
  ], 64))
}
}

})